import React from "react";
import { Link } from "react-router-dom";

// Resources page for teacher, parents, and individual written analysis
const Resources = () => {
  // Placeholder paths; replace with actual resource files in public/assets/resources
  const teacherUrl = "/assets/resources/teacher-resources.pdf";
  const parentsUrl = "/assets/resources/parents-resources.pdf";
  const analysisUrl = "/assets/resources/individual-analysis.pdf";

  const cardStyle = {
    padding: 18,
    border: "1px solid #eee",
    borderRadius: 8,
    background: "#fff",
  };

  const btnStyle = { minWidth: 180 };

  return (
    <div style={{ padding: 20 }}>
      <div style={{ marginBottom: 12 }}>
        <Link to="/" className="btn btn-outline btn-back-home">
          Back to Home
        </Link>
      </div>

      <h2 style={{ marginBottom: 8 }}>More About This Picture Book</h2>
      <p style={{ color: "#666", marginBottom: 20 }}>
        Below are resources for teachers, parents, and an individual written
        analysis. Click to open in a new tab or download.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 16,
          maxWidth: 1000,
          margin: "0 auto",
        }}
      >
        <div style={cardStyle}>
          <h3>Teacher Resource</h3>
          <p style={{ color: "#555" }}>Classroom guides to teach self regulation.</p>
          <div style={{ marginTop: 12 }}>
            <a
              href={teacherUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-main"
              style={btnStyle}
            >
              Open
            </a>
            <a
              href={teacherUrl}
              download
              className="btn btn-outline"
              style={{ marginLeft: 8, ...btnStyle }}
            >
              Download
            </a>
          </div>
        </div>

        <div style={cardStyle}>
          <h3>Parents Resource</h3>
          <p style={{ color: "#555" }}>
            Guide to support your child's learning at home.
          </p>
          <div style={{ marginTop: 12 }}>
            <a
              href={parentsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-main"
              style={btnStyle}
            >
              Open
            </a>
            <a
              href={parentsUrl}
              download
              className="btn btn-outline"
              style={{ marginLeft: 8, ...btnStyle }}
            >
              Download
            </a>
          </div>
        </div>

        <div style={cardStyle}>
          <h3>Individual Written Analysis</h3>
          <p style={{ color: "#555" }}>
            Individual written analysis of the picture book.
          </p>
          <div style={{ marginTop: 12 }}>
            <a
              href={analysisUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-main"
              style={btnStyle}
            >
              Open
            </a>
            <a
              href={analysisUrl}
              download
              className="btn btn-outline"
              style={{ marginLeft: 8, ...btnStyle }}
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;
